import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ClientConfigurationsController } from './client-configurations.controller';
import { ClientConfigurationsService } from './client-configurations.service';
import { Division } from './entities/division-entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([Division])
  ],
  controllers: [ClientConfigurationsController],
  providers: [ClientConfigurationsService]
})
export class ClientConfigurationsModule { }
